import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ReactComponent as DangerIcon } from "../../asserts/logo/Danger.svg";

const BTN_SHADOW = "0px 1px 2px 0px #0000000A";

const PRIMARY_BTN_BG =
  "linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.25) 100%), linear-gradient(0deg, #005BF0, #005BF0)";

const PRIMARY_BTN_BG_HOVER =
  "linear-gradient(180deg, rgba(0, 0, 0, 0.08) 0%, rgba(0, 0, 0, 0.08) 100%), linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.25) 100%), linear-gradient(0deg, #005BF0, #005BF0)";

export default function ConfirmFieldUpdateDialog({
  open,
  title,
  description,
  confirmLabel = "Continue",
  onCancel,
  onConfirm,
}) {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: 600,
          maxWidth: 600,
          minHeight: 317,
          borderRadius: "4px",
          bgcolor: "#FFFFFF",
          boxShadow: "0px 10px 10px 0px #0000003D, 0px 0px 10px 0px #2122261F",
          m: 2,
          overflow: "visible",
        },
      }}
    >
      <IconButton
        onClick={onCancel}
        aria-label="Close"
        sx={{
          position: "absolute",
          right: 16,
          top: 16,
          color: "#555555",
          p: 0.5,
        }}
      >
        <CloseIcon sx={{ fontSize: 20 }} />
      </IconButton>

      <DialogContent
        sx={{
          boxSizing: "border-box",
          p: "40px 64px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "16px",
          textAlign: "center",
          overflow: "visible",
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: 64,
            height: 64,
            flexShrink: 0,
            "& path": { fill: "#FFAB00" },
          }}
        >
          <DangerIcon
            style={{
              position: "absolute",
              top: 12.8,
              left: 10.67,
              width: 42.55352020263672,
              height: 38.26918029785156,
              display: "block",
            }}
            aria-hidden
          />
        </Box>

        <Typography
          sx={{
            fontFamily: "Lato, sans-serif",
            fontWeight: 900,
            fontSize: 20,
            lineHeight: "27px",
            letterSpacing: 0,
            color: "#000000",
            width: "100%",
            maxWidth: 472,
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{
            fontFamily: "Lato, sans-serif",
            fontWeight: 400,
            fontSize: 14,
            lineHeight: "21px",
            letterSpacing: 0,
            color: "#555555",
            width: "100%",
            maxWidth: 472,
            whiteSpace: "pre-line",
          }}
        >
          {description}
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexWrap: "nowrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "16px",
            mt: 0.5,
          }}
        >
          <Button
            variant="outlined"
            onClick={onCancel}
            sx={{
              textTransform: "none",
              fontFamily: "Lato, sans-serif",
              fontWeight: 700,
              fontSize: 15,
              lineHeight: "24px",
              letterSpacing: 0,
              width: 77,
              minWidth: 77,
              height: 40,
              minHeight: 40,
              py: "8px",
              px: "16px",
              gap: "4px",
              bgcolor: "#FFFFFF",
              color: "#005BF0",
              borderRadius: "4px",
              border: "1px solid #005BF0",
              boxShadow: BTN_SHADOW,
              "&:hover": {
                bgcolor: "#F0F6FF",
                border: "1px solid #005BF0",
                boxShadow: BTN_SHADOW,
              },
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={onConfirm}
            disableElevation
            sx={{
              textTransform: "none",
              fontFamily: "Lato, sans-serif",
              fontWeight: 700,
              fontSize: 15,
              lineHeight: "24px",
              letterSpacing: 0,
              minWidth: 100,
              width: "auto",
              height: 40,
              minHeight: 40,
              py: "8px",
              px: "16px",
              gap: "4px",
              whiteSpace: "nowrap",
              flexShrink: 0,
              color: "#FFFFFF",
              borderRadius: "4px",
              border: "1px solid transparent",
              boxShadow: BTN_SHADOW,
              backgroundColor: "transparent",
              backgroundImage: PRIMARY_BTN_BG,
              "&:hover": {
                backgroundColor: "transparent",
                backgroundImage: PRIMARY_BTN_BG_HOVER,
                boxShadow: BTN_SHADOW,
              },
            }}
          >
            {confirmLabel}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
